import { cookie, setCookie } from '../../utils/index';
import { notifyPopup, notifyInfo } from '../../utils/fetch';

// 浏览器通知
export default () => {
    class NotificationHandler {
        constructor() {
          this.isNotificationSupported = 'Notification' in window;
      
          notifyInfo().then((r) => {
            r.data.msg_display === 1 && this.requestNotification();
          })
        }
        getConfig(act_type, msg_id, frq_id) {
          return { union_id: cookie.get("_shopify_y"), shopify_shop_id: shopId, msg_id: msg_id || '', frq_id: frq_id || '', act_type: act_type }
        }
      
        isPermissionGranted() {
          return Notification.permission === 'granted'
        }
      
        requestPermission(agree, reject) {
          const me = this;
          if (!me.isNotificationSupported) {
            console.log('the current browser does not support Notification API');
            reject && reject()
            return
          }
      
          // status是授权状态，如果用户允许显示桌面通知，则status为'granted'
          // permission是只读属性: default 用户没有接收或拒绝授权 不能显示通知, granted 用户接受授权 允许显示通知, denied  用户拒绝授权 不允许显示通知
          Notification.requestPermission((status) => {
            const { permission } = Notification;
            console.log(`status is ${status}, permission is ${permission}`);
      
            const act_type = { granted: 1, default: 2, denied: 3 }[permission];
            if (permission === 'granted') {
              setCookie('_jk_notify_permission', permission)
              agree && agree()
            } else {
              cookie.erase('_jk_notify_permission')
              reject && reject()
            }
      
            notifyPopup(me.getConfig(act_type))
          })
        }
      
        showNotification(obj) {
          const me = this;
          if (!me.isNotificationSupported) return
          if (!this.isPermissionGranted()) return
          let n = new Notification(obj.title, { icon: obj.image_url, body: obj.describe });
      
          n.onshow = function () {
            notifyPopup(me.getConfig(5, obj.msg_id, obj.frq_id))
          };
      
          n.onclick = function () {
            // opening current view
            window.focus();
            notifyPopup(me.getConfig(4, obj.msg_id, obj.frq_id)).then(() => {
              n.close();
              window.location.href = obj.href_url
            })
          };
        }
      
        requestNotification() {
          const me = this;
          function inquiries() {
            notifyInfo().then((r) => {
              r.data.msg_display === 1 && me.showNotification(r.data);
              // if authorization status has not been changed, continue request next notification.
              me.isPermissionGranted() && setTimeout(() => {
                me.requestNotification()
              }, 150000)
            })
          }
          if (cookie.get("_jk_notify_permission")) {
            inquiries()
          } else {
            me.requestPermission(() => {
              inquiries()
            })
          }
        }
    }
    
    window.notificationHandler = new NotificationHandler()
}